export const BASE_URL = import.meta.env.BASE_URL || "";
export const API_BASE_URL = import.meta.env.VITE_APP_API_ROOT;
export const AD_APP_AUTHORITY = import.meta.env.VITE_APP_AD_AUTHORITY;
export const AD_APP_TENANT = import.meta.env.VITE_APP_AD_TENANT;
export const AD_APP_CLIENTID = import.meta.env.VITE_APP_AD_CLIENTID;
export const API_AD_APP_SCOPE = import.meta.env.VITE_API_AD_APP_SCOPE;
export const AD_API_APP_ID = import.meta.env.VITE_APP_AD_API_APP_ID;
export const ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;
export const ASSUME_ROLE_ENABLED =
  import.meta.env.VITE_ASSUME_ROLE_ENABLED?.toLowerCase() === "true";
import { TankPlanSchemaVersion } from "@/constants/SchemaVersion";
/**
 * True if the voyage management functionality is available. When this is released into production,
 * we should probably cut this flag out.
 */
export const VOYAGE_MANAGEMENT_ENABLED =
  import.meta.env.VITE_VOYAGE_MANAGEMENT_ENABLED?.toLowerCase() === "true";

export const PRODUCT_QUALITY_ENABLED =
  import.meta.env.VITE_PRODUCT_QUALITY_ENABLED?.toLowerCase() === "true";

/**
* This decides whether to use the Normal Safe Fill or Working Level/Maximum Working Level fields to retain historical plans.
* There is currently a feature flag on this set to release in May or June 2025 at the latest.
* See https://zenergy.atlassian.net/browse/SUP-793 for more information.
* 
* This is now live in production, this flag can be removed in the next release.
* Johanah G. 24/09/2025
*/
export function GetPostMSoVersion(schemaVersion: TankPlanSchemaVersion) {
  return (
    schemaVersion === TankPlanSchemaVersion.PostMSO
  );
}